@if ({ subscriptions: clientSubscriptionData | async }; as $) {
  <div class="">
    <!-- Subscription Details-->
    <div>
      <!-- Details -->
      @if (!showSkeleton && hasUpgradeSubscription($.subscriptions)) {
        <div>
          @if (getSubscriptionDetails($.subscriptions); as data) {
            <p-message
              severity="info"
              styleClass="relative"
              aria-label="subscription-upgrade-info-message"
            >
              <div class="flex align-items-center w-full -my-2 md:m-0">
                <i class="fa fa-info-circle text-xl"></i>
                @if (showSkeleton) {
                  <p-skeleton width="10rem" height="1.1rem" styleClass="mb-1" />
                }
                @if ($.subscriptions.upgrade_from_clt_subs_id > 0) {
                  <div
                    class="ml-3 text-sm"
                    [innerHTML]="'SUBSCRIPTIONS.SUBS_UPGRADE_FROM_NAME' | translate: { name: data.name_primary_language }"
                    (click)="getSubscription(data.id)"
                  ></div>
                }
                @if ($.subscriptions.upgrade_to_clt_subs_id > 0) {
                  <div
                    class="ml-3 text-sm"
                    [innerHTML]="
                      'SUBSCRIPTIONS.SUBS_UPGRADE_TO_NAME'
                        | translate: { name: data.name_primary_language }
                    "
                    (click)="getSubscription(data.id)"
                  ></div>
                }
              </div>
            </p-message>
          }
        </div>
      }
      <!-- Transfer Info Banner -->
      @if (!showSkeleton && hasTransferInfo($.subscriptions)) {
        <div>
          <p-message
            severity="warn"
            styleClass="relative"
            aria-label="subscription-transfer-info-message"
          >
            <div class="flex align-items-center w-full -my-2 md:m-0">
              <i class="fa fa-exchange-alt text-xl"></i>
              <div class="ml-3 text-sm">
                @if (isTransferredFrom($.subscriptions)) {
                  @if (isLocationTransfer($.subscriptions)) {
                    <span
                      [innerHTML]="'SUBSCRIPTIONS.SUBS_TRANSFER_FROM_CLUB' | translate: { name: getTransferFromName($.subscriptions) }"
                    ></span>
                  } @else {
                    <span
                      [innerHTML]="
                        'SUBSCRIPTIONS.SUBS_TRANSFER_FROM_CLIENT' | translate : {
                                name: getTransferFromName($.subscriptions),
                                id: getTransferFromId($.subscriptions),
                              }
                      "
                    ></span>
                  }
                }
                @if (isTransferredTo($.subscriptions)) {
                  @if (isLocationTransfer($.subscriptions)) {
                    <span
                      [innerHTML]="'SUBSCRIPTIONS.SUBS_TRANSFER_TO_CLUB' | translate : { name: getTransferToName($.subscriptions) }"
                    ></span>
                  } @else {
                    <span
                      [innerHTML]="
                        'SUBSCRIPTIONS.SUBS_TRANSFER_TO_CLIENT' | translate : {
                                name: getTransferToName($.subscriptions),
                                id: getTransferToId($.subscriptions),
                              }
                      "
                    ></span>
                  }
                }
              </div>
            </div>
          </p-message>
        </div>
      }
      <!-- Parent/Child Subscription Banner -->
      @if (!showSkeleton && (isParentSubscription() || isChildSubscription())) {
        <div>
          <p-message
            [severity]="isParentSubscription() ? 'success' : 'info'"
            styleClass="relative"
            aria-label="subscription-family-info-message"
          >
            <div class="flex align-items-center w-full -my-2 md:m-0">
              <i class="fa fa-users text-xl"></i>
              <div class="ml-3 text-sm">
                @if (isParentSubscription()) {
                  <span>{{
                    'SUBSCRIPTIONS.PARENT_SUBSCRIPTION_INFO' | translate
                  }}</span>
                }
                @if (isChildSubscription()) {
                  <span>{{
                    'SUBSCRIPTIONS.CHILD_SUBSCRIPTION_INFO' | translate
                  }}</span>
                }
              </div>
            </div>
          </p-message>
        </div>
      }
      <div
        class="surface-0 shadow-1 border-round text-sm p-3 relative overflow-hidden mt-2"
      >
        @if (hasUpgradeSubscription($.subscriptions)) {
          <div
            class="bg-pink-500 p-2 absolute z-3 text-white text-center text-xs card-badge"
          >
            <strong>{{ 'SUBSCRIPTIONS.UPGRADED' | translate }}</strong>
          </div>
        }
        @if (hasTransferInfo($.subscriptions)) {
          <div
            class="bg-indigo-500 p-2 absolute z-3 text-white text-center text-xs card-badge"
          >
            <strong>{{ 'SUBSCRIPTIONS.TRANSFERRED' | translate }}</strong>
          </div>
        }
        <!-- Heading -->
        <div class="grid">
          <div class="col-8 md:col-8">
            @if (!showSkeleton) {
              <div class="flex">
                @if (isNotRenewingStatus($.subscriptions.status)) {
                  <span
                    class="surface-300 px-2 py-1 border-round text-600 border-1 border-600 text-xs uppercase mr-2">
                    {{ 'SUBSCRIPTIONS.NOT_RENEWING' | translate }}
                  </span>
                }
                <span class="bg-blue-50 px-2 py-1 border-round text-primary border-1 border-primary text-xs mr-2 uppercase">
                  {{
                    'POS.PLANTYPE.' + $.subscriptions.subscription_category.toUpperCase()| translate
                  }}
                </span>
                @if (!isNotRenewingStatus($.subscriptions.status)) {
                  <span
                    class="px-2 py-1 flex align-items-center justify-content-center border-round text-white text-xxs mr-3 uppercase"
                    [ngClass]="showSubscriptionStatus($.subscriptions.status)"
                  >
                    {{
                      'SUBSCRIPTIONS.STATUS.' + $.subscriptions.status | translate
                    }}
                  </span>
                }
                @if (isNotRenewingStatus($.subscriptions.status)) {
                  <span
                    class="px-2 py-1 flex align-items-center justify-content-center border-round text-white text-xxs uppercase mr-3 bg-green-500"
                  >
                    {{ $.subscriptions.state | titlecase }}
                  </span>
                }
                <!-- See What's Pending Tag -->
                @if (isPendingForMandatoryAction($.subscriptions.status)) {
                  <span
                    class="bg-orange-100 text-orange-600 px-2 py-1 border-round text-xs cursor-pointer hover:bg-orange-200 transition-colors"
                    (click)="showPendingActionsDetails($.subscriptions, $event)"
                    aria-label="see-whats-pending-tag"
                  >
                    {{ 'SUBSCRIPTIONS.SEE_WHATS_PENDING' | translate }}
                  </span>
                }
                @if (
                  isRecurringSubscription($.subscriptions) &&
                  isBillingStopped($.subscriptions)
                ) {
                  <span
                    class="px-2 py-1 flex align-items-center justify-content-center border-round text-white text-xxs mr-2 uppercase bg-red-500 white-space-nowrap"
                    aria-label="billing-status-stopped"
                  >
                    <i class="fa fa-exclamation-circle mr-1"></i>
                    {{
                      'SUBSCRIPTIONS.BILLING_STOPPED_BADGE' | translate
                    }}
                  </span>
                }
                @if (isPresalePurchased($.subscriptions)) {
                  <p-tag
                    styleClass="text-xxs font-normal uppercase bg-purple-500 font-bold white-space-nowrap mr-2"
                    >{{ 'TENANT.PRESALE' | translate }}</p-tag
                  >
                }
                <span class="flex align-items-center">
                  <i class="fa fa-map-marker-alt text-xl text-600 mr-1"></i>
                  @if (getTenant($.subscriptions.tenant_id); as tenant) {
                    <span>{{
                      tenant.name_primary_language ||
                        tenant.name_secondary_language
                    }}</span>
                  }
                </span>
              </div>
            }
            <!-- Badges Skeleton -->
            @if (showSkeleton) {
              <div class="flex flex-wrap align-items-center">
                <p-skeleton width="5rem" height="1.5rem" styleClass="mr-2" />
                <p-skeleton width="5rem" height="1.5rem" styleClass="mr-2" />
                <p-skeleton width="5rem" height="1.5rem" styleClass="mr-2" />
                <p-skeleton width="5rem" height="1.5rem" styleClass="mr-2" />
              </div>
            }
            <!-- Badges Skeleton -->
            @if (!showSkeleton) {
              <div>
                <h3 class="my-2 font-bold text-base md:text-lg">
                  <span class="inline-block mr-3">{{
                    $.subscriptions.name_primary_language || $.subscriptions.name_secondary_language
                  }}</span>
                  <span class="text-xs text-500" >{{ 'SUBSCRIPTIONS.SUB' | translate }}{{ $.subscriptions.id }}</span>
                </h3>
                @if (!isRecurringSubscription($.subscriptions)) {
                  <p class="mb-1 mt-2">
                    <!-- {{'SUBSCRIPTIONS.MONTHLY-SUBSCRIPTIONS' | translate}} -->
                    @for (
                      membership of $.subscriptions.recurring_template_recurring_services; 
                      track membership;
                      let i = $index
                    ) {
                      @if (membership.service_is_base_membership) {
                        <span
                          class="inline-block px-2 line-height-4 text-xxs surface-200 border-round mx-2 my-1"
                        >
                          {{ 'SUBSCRIPTIONS.BASE-MEMEBERSHIP' | translate }}
                        </span>
                      }
                      <br class="md:hidden" />
                      <span>{{
                        membership.service_type_name_primary_language || membership.service_type_name_secondary_language
                      }}</span>
                      @if (
                        $.subscriptions.recurring_template_recurring_services.length > 0 &&
                        $.subscriptions.recurring_template_recurring_services.length - 1 !== i
                      ) {
                        <span>+</span>
                      }
                    }
                  </p>
                }
                @if (
                  $.subscriptions.description_primary_language || $.subscriptions.description_secondary_language
                ) {
                  <p class="mb-2 text-xs text-600">
                    {{
                      $.subscriptions.description_primary_language || $.subscriptions.description_secondary_language
                    }}
                  </p>
                }
                @if (isPayAsYouGoSubscription($.subscriptions)) {
                  <p class="mb-1 mt-2">
                    {{ 'SUBSCRIPTIONS.MONTHLY-SUBSCRIPTIONS' | translate }}
                    @for (
                      membership of $.subscriptions.recurring_template_recurring_services;
                      track membership;
                      let i = $index
                    ) {
                      @if (membership.service_category_name_primary_language) {
                        <span>
                          {{
                            membership.service_category_name_primary_language || membership.service_category_name_secondary_language
                          }}
                        </span>
                      }
                      @if (membership.service_is_base_membership) {
                        <span
                          class="inline-block px-2 line-height-4 text-xxs surface-200 border-round mx-2 my-1"
                        >
                          {{ 'SUBSCRIPTIONS.BASE-MEMEBERSHIP' | translate }}
                        </span>
                      }
                      <br class="md:hidden" />
                      @if (
                        $.subscriptions.recurring_template_recurring_services.length > 0 &&
                        $.subscriptions.recurring_template_recurring_services.length - 1 !== i
                      ) {
                        <span>, </span>
                      }
                    }
                  </p>
                }
              </div>
            }
            @if (showSkeleton) {
              <div>
                <div class="flex align-items-center my-2">
                  <p-skeleton width="18rem" height="1.3rem" styleClass="mr-2" />
                  <p-skeleton width="5rem" height="1.3rem" />
                </div>
                <p-skeleton width="100%" height="1.1rem" styleClass="mb-2" />
                <p-skeleton width="100%" height="1.1rem" styleClass="mb-1" />
              </div>
            }
          </div>
          @if (
            !showSkeleton &&
            isRecurringSubscription($.subscriptions) &&
            !isPayAsYouGoSubscription($.subscriptions)
          ) {
            <div
              class="col-12 md:col-4 flex align-items-center md:justify-content-end line-height-1 mb-1 mt-5 md:mb-0 md:pr-8"
            >
              <div class="inline-block">
                @if (!showSkeleton) {
                  <strong class="text-lg line-height-1"
                    >{{ $.subscriptions.recurring_revenue | currencyformat }}
                  </strong>
                }
                @if (
                  isRecurringSubscription($.subscriptions) && !showSkeleton
                ) {
                  <sub class="ml-1 mt-2">
                    /
                    {{
                      $.subscriptions.billing_interval_value > 1
                        ? $.subscriptions.billing_interval_value.toString()
                        : ''
                    }}
                    {{
                      'POS.MEMBERSHIP_ADDON.' +
                        getInterval(
                          $.subscriptions.billing_interval_value,
                          $.subscriptions.billing_interval_type
                        ) | translate
                    }}
                  </sub>
                }
                @if (!showSkeleton) {
                  <div class="text-xs text-600 font-italic text-right">
                    {{ 'SUBSCRIPTIONS.INCLU_TAX' | translate }}
                  </div>
                }
                @if (showSkeleton) {
                  <p-skeleton width="4rem" height="1.25rem" />
                }
                @if (showSkeleton) {
                  <p-skeleton width="2rem" height="1.1rem" styleClass="ml-1" />
                }
              </div>
            </div>
          }
          @if (showSkeleton) {
            <div
              class="col-12 md:col-4 flex align-items-center md:justify-content-end line-height-1 mb-1 mt-5 md:mb-0 md:pr-8"
            >
              <div class="inline-block">
                @if (showSkeleton) {
                  <p-skeleton width="4rem" height="1.25rem" />
                }
                @if (showSkeleton) {
                  <p-skeleton width="2rem" height="1.1rem" styleClass="ml-1" />
                }
              </div>
            </div>
          }
          @if (!showSkeleton) {
            <div
              class="absolute right-0 top-0 mt-2 mr-2 flex align-items-center justify-content-end"
            >
              @if (!showSkeleton) {
                <subscription-action-list
                  [clientId]="clientId()"
                  [tenantId]="tenantId"
                  [subscriptionId]="subscriptionId()"
                  [subscription]="$.subscriptions"
                  [paymentTimelineData]="paymentTimelineData"
                  [showFreeDiscount]="true"
                  (emitEvents)="ActionsEmitEvents($event)"
                  (closeAddonEvent)="closeAddonSidebar($event)"
                />
              }
            </div>
          }
          @if (showSkeleton) {
            <div class="absolute right-0 top-0 mt-4 mr-3">
              <p-skeleton width="5.2rem" height="2rem" />
            </div>
          }
        </div>
        <!-- Heading -->
        @if (!showSkeleton && isStatusOverridden($.subscriptions)) {
          <p-message
            severity="warn"
            styleClass="relative w-full mb-3"
            aria-label="manual-override-banner"
          >
            <div class="flex flex-column md:flex-row align-items-start md:align-items-center justify-content-between w-full gap-2">
              <div class="flex align-items-start">
                <i class="fa fa-exclamation-triangle text-xl mr-2 mt-1"></i>
                <span class="text-sm">
                  {{ 'SUBSCRIPTIONS.MANUAL_OVERRIDE_BANNER_TEXT' | translate }}
                </span>
              </div>
              @if (showSubscriptionStatusOverride.value) {
                <button
                  pButton
                  pRipple
                  type="button"
                  [label]="'SUBSCRIPTIONS.BTN_CLEAR_OVERRIDE' | translate"
                  class="p-button-outlined p-button-warning text-sm white-space-nowrap"
                  (click)="openClearOverrideModal()"
                  aria-label="clear-override-button"
                ></button>
              }
            </div>
          </p-message>
        }
        <!-- Content -->
        @if (!showSkeleton) {
          <div class="grid my-0">
            <!-- Card -->
            @if (isRecurringSubscription($.subscriptions)) {
              <div class="col-6 xl:col-3">
                <div
                  class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center"
                >
                  <div>
                    <i
                      class="fa fa-hand-holding-dollar mb-2 text-lg line-height-1"
                    ></i>
                    <h6 class="font-medium text-700 text-xs mb-2">
                      {{ 'SUBSCRIPTIONS.COMMITMENT-PAID' | translate }}
                    </h6>
                    <strong class="block text-base line-height-1">
                      {{ $.subscriptions.billing_interval_completed | number }}
                      <span class="font-normal"
                        ><span>/</span>
                        {{ $.subscriptions.contract_term | number }}</span
                      >
                    </strong>
                  </div>
                </div>
              </div>
            }
            <!-- Card -->
            <!-- Card -->
            @if (isRecurringSubscription($.subscriptions)) {
              <div class="col-6 xl:col-3">
                <div
                  class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center"
                >
                  <div class="flex flex-column h-full">
                    <div class="flex-1 flex flex-column justify-content-center">
                      <i class="fa fa-hourglass mb-2 text-lg line-height-1"></i>
                      <h6 class="font-medium text-700 text-xs mb-2">
                        {{ 'SUBSCRIPTIONS.BILLING-FREQUENCY' | translate }}
                      </h6>
                      <strong class="block text-base line-height-1">
                        {{
                          GetBillingFrequency(
                            $.subscriptions.billing_interval_type,
                            $.subscriptions.billing_interval_value,
                            $.subscriptions.bill_cycle_day
                          )
                        }}
                      </strong>
                    </div>
                    <!-- Error Message -->
                    <div class="mt-2">
                      <p-message
                        severity="error"
                        aria-label="subscription-contract-expiry-message"
                        styleClass="w-full"
                      >
                        @if (
                          $.subscriptions.on_contract_expiry ==='ContractExpire') {
                          <div class="flex align-items-center w-full text-xs">
                            <i class="fa fa-times-circle mr-2"></i>
                            <div>
                              {{ 'SUBSCRIPTIONS.ContractExpire' | translate }}
                            </div>
                          </div>
                        }
                        @if (
                          $.subscriptions.on_contract_expiry === 'ContractAutoRenew') {
                          <div class="flex align-items-center w-full text-xs">
                            <i class="fa fa-times-circle mr-2"></i>
                            <div>
                              {{
                                'SUBSCRIPTIONS.ContractAutoRenew' | translate
                              }}
                            </div>
                          </div>
                        }
                        @if (
                          $.subscriptions.on_contract_expiry === 'ContractConvertsToPayAsYouGo'
                        ) {
                          <div class="flex align-items-center w-full text-xs">
                            <i class="fa fa-times-circle mr-2"></i>
                            <div>
                              {{
                                'SUBSCRIPTIONS.ContractConvertsToPayAsYouGo' | translate
                              }}
                            </div>
                          </div>
                        }
                      </p-message>
                    </div>
                    <!-- Error Message -->
                  </div>
                </div>
              </div>
            }
            <!-- Card -->
            <!-- Card -->
            @if (isRecurringSubscription($.subscriptions)) {
              <div class="col-6 xl:col-3">
                <div
                  class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center"
                >
                  <div>
                    <i
                      class="fa fa-calendar-minus mb-2 text-lg line-height-1"
                    ></i>
                    <h6 class="font-medium text-700 text-xs mb-2">
                      {{ 'SUBSCRIPTIONS.CONTRACT-END' | translate }}
                    </h6>
                    <strong class="block text-base line-height-1">{{
                      $.subscriptions.end_date | datetimeformat: 'mediumDate'
                    }}</strong>
                  </div>
                </div>
              </div>
            }
            <!-- Card -->
            <!-- Card -->
            @if (isRecurringSubscription($.subscriptions)) {
              <div class="col-6 xl:col-3">
                <div
                  class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center"
                >
                  <div>
                    <i
                      class="fa fa-calendar-plus mb-2 text-lg line-height-1"
                    ></i>
                    <h6 class="font-medium text-700 text-xs mb-2">
                      {{ 'SUBSCRIPTIONS.NEXT-BILLING-DATE' | translate }}
                    </h6>
                    <strong class="block text-base line-height-1">{{
                      $.subscriptions.next_charge_date | datetimeformat: 'mediumDate'
                    }}</strong>
                  </div>
                </div>
              </div>
            }
            <!-- Card -->
            <!-- Card -->
            <div class="col-6 xl:col-3">
              <div
                class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center"
              >
                <div>
                  <i
                    class="fa fa-calendar-check mb-2 text-lg line-height-1"
                  ></i>
                  <h6 class="font-medium text-700 text-xs mb-2">
                    {{ 'SUBSCRIPTIONS.START-DATE' | translate }}
                  </h6>
                  <strong class="block text-base line-height-1 mb-2">{{
                    $.subscriptions.start_date | datetimeformat: 'mediumDate'
                  }}</strong>
                  @if (!isRecurringSubscription($.subscriptions)) {
                    <p-button
                      [ngClass]="CanEditDates($.subscriptions.status) || isTenantPresale.value ? 'opacity-40 pointer-events-none' : ''"
                      [label]="'common.BUTTONS.BUTTON_TEXT_EDIT' | translate"
                      icon="fa fa-pencil"
                      (click)="showEditStartEndDate = true"
                      styleClass="text-xs text-600 surface-0 p-button-outlined p-button-secondary border-400 py-1 px-2 ml-2 mt-1"
                    />
                  }
                </div>
              </div>
            </div>
            <!-- Card -->
            <!-- Card -->
            @if (!isRecurringSubscription($.subscriptions)) {
              <div class="col-6 xl:col-3">
                <div
                  class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center"
                >
                  <div>
                    <i
                      class="fa fa-hand-holding-dollar mb-2 text-lg line-height-1"
                    ></i>
                    <h6 class="font-medium text-700 text-xs mb-2">
                      {{ 'SUBSCRIPTIONS.END_DATE' | translate }}
                    </h6>
                    <strong class="block text-base line-height-1">
                      {{
                        $.subscriptions.end_date | datetimeformat: 'mediumDate'
                      }}
                    </strong>
                  </div>
                </div>
              </div>
            }
            <!-- Card -->
            <!-- Card -->
            @if (isRecurringSubscription($.subscriptions)) {
              <div class="col-6 xl:col-3">
                <div
                  class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center"
                >
                  <div>
                    <i class="fa fa-calendar mb-2 text-lg line-height-1"></i>
                    <h6 class="font-medium text-gray-700 text-xs mb-2">
                      {{ 'SUBSCRIPTIONS.SIGN-UP-DATE' | translate }}
                    </h6>
                    <strong class="block text-base line-height-1">{{ $.subscriptions.sign_up_date | datetimeformat: 'mediumDate' }}</strong>
                  </div>
                </div>
              </div>
            }
            <!-- Card -->
            <!-- Card -->
            @if (isRecurringSubscription($.subscriptions)) {
              <div class="col-6 xl:col-3">
                <div
                  class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center"
                >
                  <div>
                    <i
                      class="fa fa-hand-holding-dollar mb-2 text-lg line-height-1"
                    ></i>
                    <h6 class="font-medium text-gray-700 text-xs mb-2">
                      {{ 'SUBSCRIPTIONS.BILLING_STATUS' | translate }}
                    </h6>
                    <div
                      class="flex align-items-center justify-content-center"
                    >
                      @if (isBillingStopped($.subscriptions)) {
                        <p-message
                          class="text-xs"
                          icon="fa fa-exclamation-circle"
                          severity="error"
                          aria-label="subscription-billing-stopped-message"
                        >
                          <div
                            class="flex align-items-center justify-content-center"
                          >
                            <span>{{
                              'SUBSCRIPTIONS.BILLING_STATUS_STOPPED'
                                | translate
                            }}</span>
                          </div>
                        </p-message>
                      } @else {
                        <p-message
                          class="text-xs"
                          icon="fa fa-check-circle"
                          severity="success"
                          aria-label="subscription-billing-active-message"
                        >
                          <div
                            class="flex align-items-center justify-content-center"
                          >
                            <span>{{
                              'SUBSCRIPTIONS.BILLING_STATUS_ACTIVE'
                                | translate
                            }}</span>
                          </div>
                        </p-message>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (isRecurringSubscription($.subscriptions)) {
              <div class="col-6 xl:col-3">
                <div
                  class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center"
                >
                  <div>
                    <i class="fa fa-credit-card mb-2 text-lg line-height-1"></i>
                    <h6 class="font-medium text-gray-700 text-xs mb-2">
                      {{ 'SUBSCRIPTIONS.AUTO_PAY' | translate }}
                    </h6>
                    <div class="flex align-items-center justify-content-center">
                      @if ($.subscriptions.feature_is_cash_recurring) {
                        <p-message
                          class="text-xs"
                          icon="fa fa-times-circle"
                          severity="error"
                          aria-label="subscription-autopay-off-message"
                        >
                          <div
                            class="flex align-items-center justify-content-center"
                          >
                            <span>Off</span>
                          </div>
                        </p-message>
                      }
                      @if (
                        $.subscriptions.feature_is_cash_recurring === false
                      ) {
                        <p-message
                          class="text-xs"
                          icon="fa fa-check-circle"
                          severity="success"
                          aria-label="subscription-autopay-on-message"
                        >
                          <div
                            class="flex align-items-center justify-content-center"
                          >
                            <span>On</span>
                          </div>
                        </p-message>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
            <!-- Card -->
            <!-- Card -->
            @if (
              isRecurringSubscription($.subscriptions) &&
              $.subscriptions.primary_payment_method
            ) {
              <div class="col-12 md:col-3">
                <div
                  class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center"
                >
                  <!-- <p-button *ngIf="!showSkeleton" icon="fa fa-pen" styleClass="p-button-text text-primary absolute right-0 top-0"></p-button> -->
                  <div class="mb-2">
                    <img src="assets/img/icons/icon-payment.svg" alt="Image" />
                  </div>
                  <h6 class="text-xs mb-2 text-700 font-medium">
                    {{ 'SUBSCRIPTIONS.PRIMARY_PAYMENT_METHOD' | translate }}
                  </h6>
                  <div
                    class="flex align-items-center justify-content-center text-sm"
                  >
                    @if (PaymentMethodDetails($.subscriptions.primary_payment_method);as paymentData) {
                      <strong class="flex align-items-center line-height-1">
                        <img
                          [src]="paymentData.img"
                          alt="Payment Method Logo"
                          class="h-2rem max-w-4rem object-contain flex-shrink-0 mr-2"
                        />
                        <span class="mx-2">{{ paymentData.number }}</span>
                        <i
                          [class]="
                            getTokenStatusIcon(
                              $.subscriptions.primary_payment_method
                                .token_status
                            ) +
                            ' ' +
                            getTagStyle(
                              $.subscriptions.primary_payment_method
                                .token_status
                            )
                          "
                          [pTooltip]="
                            getTokenStatusTooltip(
                              $.subscriptions.primary_payment_method
                                .token_status
                            )
                          "
                          tooltipPosition="top"
                          aria-label="primary-payment-token-status"
                        ></i>
                      </strong>
                    }
                  </div>
                  @if ($.subscriptions.primary_payment_method.token_status) {
                    <div class="mt-2 text-xs text-center">
                      <p-message
                        [severity]="
                          $.subscriptions.primary_payment_method
                            .token_status === 'confirmed'
                            ? 'success'
                            : 'warn'
                        "
                        [text]="
                          getTokenStatusMessage(
                            $.subscriptions.primary_payment_method.token_status
                          )
                        "
                        styleClass="text-xs w-full"
                        aria-label="primary-payment-token-message"
                      />
                    </div>
                  }
                </div>
              </div>
            }
            <!-- Card -->
            <!-- Card -->
            @if (
              isRecurringSubscription($.subscriptions) &&
              $.subscriptions.secondary_payment_method
            ) {
              <div class="col-12 md:col-3">
                <div
                  class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center"
                >
                  <!-- <p-button *ngIf="!showSkeleton" icon="fa fa-pen" styleClass="p-button-text text-primary absolute right-0 top-0"></p-button> -->
                  <div class="mb-2">
                    <img src="assets/img/icons/icon-payment.svg" alt="Image" />
                  </div>
                  <h6 class="text-xs mb-2 text-700 font-medium">
                    {{ 'SUBSCRIPTIONS.SECONDARY_PAYMENT_METHOD' | translate }}
                  </h6>
                  <div
                    class="flex align-items-center justify-content-center text-sm"
                  >
                    @if (
                      PaymentMethodDetails(
                        $.subscriptions.secondary_payment_method
                      );
                      as paymentData
                    ) {
                      <strong class="flex align-items-center line-height-1">
                        <img
                          [src]="paymentData.img"
                          alt="Payment Method Logo"
                          class="h-2rem max-w-4rem object-contain flex-shrink-0 mr-2"
                        />
                        <span class="mx-2">{{ paymentData.number }}</span>
                        <i
                          [class]="
                            getTokenStatusIcon($.subscriptions.secondary_payment_method.token_status) +
                            ' ' +
                            getTagStyle($.subscriptions.secondary_payment_method.token_status)
                          "
                          [pTooltip]="
                            getTokenStatusTooltip($.subscriptions.secondary_payment_method.token_status)
                          "
                          tooltipPosition="top"
                          aria-label="secondary-payment-token-status"
                        ></i>
                      </strong>
                    }
                  </div>
                  @if ($.subscriptions.secondary_payment_method.token_status) {
                    <div class="mt-2 text-xs text-center">
                      <p-message
                        [severity]="$.subscriptions.secondary_payment_method.token_status === 'confirmed' ? 'success' : 'warn'"
                        [text]="getTokenStatusMessage($.subscriptions.secondary_payment_method.token_status)"
                        styleClass="text-xs w-full"
                        aria-label="secondary-payment-token-message"
                      />
                    </div>
                  }
                </div>
              </div>
            }
            <!-- Card -->
            <!-- Card -->
            <!-- Add Payment Method Card -->
             @if(false) {
              <div class="col-12 md:col-3">
                <div
                  class="shadow-2 h-7rem rounded p-3 text-center relative h-full flex flex-column justify-content-center text-primary"
                >
                  <div class="mb-2">
                    <img
                      src="assets/img/icons/icon-add-secondary-payment.svg"
                      alt="Image"
                    />
                  </div>
                  @if ($.subscriptions.primary_payment_method === null) {
                    <h6 class="text-sm mb-0 font-bold">
                      {{ 'SUBSCRIPTIONS.ADD_PRI_PAYMENT_METHOD' | translate }}
                    </h6>
                  }
                  @if ($.subscriptions.secondary_payment_method === null) {
                    <h6 class="text-sm mb-0 font-bold">
                      {{ 'SUBSCRIPTIONS.ADD_SEC_PAYMENT_METHOD' | translate }}
                    </h6>
                  }
                </div>
              </div>
            }
            <!-- Card -->
          </div>
        }
        <!-- Cards Skeleton -->
        @if (showSkeleton) {
          <div class="grid my-0">
            <!-- Card -->
            @for (card of [1, 2, 3, 4, 5, 6, 7]; track card) {
              <div class="col-6 xl:col-3">
                <div
                  class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center"
                >
                  <div>
                    <div class="mb-2">
                      <p-skeleton
                        width="2rem"
                        height="2rem"
                        styleClass="mx-auto"
                      />
                    </div>
                    <p-skeleton
                      width="8rem"
                      height="1.1rem"
                      styleClass="mb-2 mx-auto"
                    />
                    <p-skeleton
                      width="4rem"
                      height="1rem"
                      styleClass="mx-auto"
                    />
                  </div>
                </div>
              </div>
            }
            <!-- Card -->
          </div>
        }
        <!-- Cards Skeleton -->
      </div>
      <!-- Products -->
      <div class="surface-0 text-sm mt-3">
        <!-- Header -->
        <div class="p-3 border-bottom-1 border-300 text-base">
          <strong>{{ 'SUBSCRIPTIONS.SERVICES.PRODUCT' | translate }}</strong>
        </div>
        <!-- Header -->
        <!-- Content -->
        <div class="p-2">
          <app-subscription-services
            [subscription]="subscriptionById"
            [clientId]="clientId()"
            [restrictToDateChange]="isTenantPresale.value"
            [tenantId]="tenantId"
          />
        </div>
        <!-- Content -->
      </div>
      <!-- Products -->
     
      <!-- Subscription Clients -->
      @if (
        !showSkeleton &&
        subscriptionById &&
        (isParentSubscription() || isChildSubscription())
      ) {
        <div class="surface-0 text-sm mt-3">
          <!-- Header -->
          <div class="p-3 border-bottom-1 border-300 text-base">
            <strong>{{ 'SUBSCRIPTIONS.CLIENTS.TITLE' | translate }}</strong>
          </div>
          <!-- Header -->
          <!-- Content -->
          <div class="p-1">
            <subscription-clients
              [subscription]="subscriptionById"
              [clientId]="clientId()"
              [tenantId]="tenantId"
            />
          </div>
          <!-- Content -->
        </div>
      }
      <!-- Subscription Clients -->
      <!-- Deposit Details -->
      @if (!showSkeleton && subscriptionById && showDeposit) {
        <div class="mt-3 text-sm surface-0">
          <app-data-grid
            [columnData]="depositTableData"
            [columns]="depositTablecolumns"
            [selectable]="false"
            [paginator]="false"
            [loading]="showSkeleton"
            [gridName]="'deposit-list'"
          />
        </div>
      }
      <!-- Deposit Details -->
      <!-- Payment Timeline -->
      @if (
        !showPaymentTimelineSkeleton$.getValue() &&
        paymentTimelineData.value &&
        paymentTimelineData.value.length > 0
      ) {
        <payment-timeline
          [paymentTimelineData]="paymentTimelineData.getValue()"
          [subscription]="subscriptionById"
          [clientId]="clientId()"
          [subscriptionId]="subscriptionId()"
          [canShowEditOccurrence]="showFreeDiscountApply.getValue()"
          (timelineUpdated)="onPaymentTimelineRefreshed($event)"
        />
      }
      @if (showPaymentTimelineSkeleton$.getValue()) {
        <div class="p-3">
          <p-skeleton width="100%" height="100px" />
        </div>
      }
      <!-- Payment Timeline -->
      <!-- Invoices -->
      <div class="surface-0 text-sm mt-3">
        <!-- Header -->
        <div class="p-3 border-bottom-1 border-300 text-base">
          <strong>{{ 'SUBSCRIPTIONS.INVOICES' | translate }}</strong>
        </div>
        <!-- Header -->
        <!-- Content -->
        <div class="p-2">
          <invoice-tab
            [clientId]="clientId()"
            [tenantId]="tenantId"
            [subscriptionId]="subscriptionId()"
            [showHeader]="false"
            [showTableActions]="!IsUpgraded"
            [loading]="showSkeleton"
          />
        </div>
        <!-- Content -->
      </div>
      <!-- Invoices -->
      <!-- Freeze List -->
      <div class="surface-0 text-sm mt-3">
        <!-- Header -->
        <div class="p-3 border-bottom-1 border-300 text-base">
          <strong>{{ 'FREEZE.FREEZE_LIST.TITLE' | translate }}</strong>
        </div>
        <!-- Header -->
        <!-- Content -->
        <div class="p-2">
          <lib-freeze-list-tab
            [clientId]="clientId()"
            [tenantId]="tenantId"
            [subscriptionId]="subscriptionId()"
            [showHeader]="false"
            [showTableActions]="!IsUpgraded"
            aria-label="subscription-freeze-list"
          />
        </div>
        <!-- Content -->
      </div>
      <!-- Freeze List -->
       
        <!-- Guest Pass -->
      <div class="surface-0 text-sm mt-3" [attr.data-testid]="'guest-pass-section'">
        <!-- Header -->
        <div class="p-3 border-bottom-1 border-300 text-base">
          <strong>{{ 'GUEST_PASS.LIST.TITLE' | translate }}</strong>
        </div>
        <!-- Header -->
        <!-- Content -->
        <div class="p-2">
          <guest-pass-summary
            [clientId]="clientId()"
            [tenantId]="tenantId"
            [subscriptionId]="subscriptionId()"
            aria-label="subscription-guest-pass-summary"
            data-testid="subscription-guest-pass-summary"
          />
        </div>
        <!-- Content -->
      </div>
      <!-- Guest Pass -->

      <!-- Guest Pass Redemptions -->
      <div class="surface-0 text-sm mt-3" [attr.data-testid]="'guest-pass-redemptions-section'">
        <!-- Header -->
        <div class="p-3 border-bottom-1 border-300 text-base">
          <strong>{{ 'GUEST_PASS.LIST.REDEMPTIONS_TITLE' | translate }}</strong>
        </div>
        <!-- Header -->
        <!-- Content -->
        <div class="p-2">
          <guest-pass-list-tab
            [clientId]="clientId()"
            [tenantId]="tenantId"
            [subscriptionId]="subscriptionId()"
            [showHeader]="false"
            aria-label="subscription-guest-pass-redemptions"
            data-testid="subscription-guest-pass-redemptions"
          />
        </div>
        <!-- Content -->
      </div>
      <!-- Guest Pass Redemptions -->
    </div>
    <!-- Subscription Details-->
  </div>
}

<!-- Invoice Modal  -->
@if (showInvoicePopup) {
  <invoice-details
    [showInvoice]="showInvoicePopup"
    [clientId]="clientId()"
    [tenantId]="tenantId"
    (closeInvoice)="closeInvoicePopup($event)"
  />
}
<!-- Invoice Modal -->

@if (showEditStartEndDate) {
  <subscription-start-end-date-edit
    [visible]="showEditStartEndDate"
    [clientId]="clientId()"
    [tenantId]="tenantId"
    [subscription]="subscriptionById"
    [membershipId]="membershipId"
    (closeEvent)="closeDateChangeEvent($event)"
    (reloadSubscription)="reloadData($event)"
  />
}

@if (showBillingSidebar) {
  <billing
    [planSummarydata]="planSummarydataObject"
    [showPosBilling]="false"
    [showbilling]="true"
    closeOnEscape="false"
    (closeSidePopupMember)="HideBillingSummary($event)"
    (GoToClientSubscription)="GoToClientDetails($event)"
  />
}

<!-- Pending Actions Popup -->
<pending-actions-popup
  [visible]="showPendingActionsPopup"
  [pendingDetails]="selectedPendingDetails"
  [isAutopayEnabled]="selectedSubscriptionAutopay"
  (closePopup)="closePendingActionsPopup()"
/>

<!-- Clear Override Modal -->
<p-dialog
  [visible]="showClearOverrideModal"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '500px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <form [formGroup]="clearOverrideForm">
      <div
        class="p-3 sticky w-full top-0 right-0 surface-0 z-1 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        <h4 class="text-base font-normal mb-0">
          {{ 'SUBSCRIPTIONS.CLEAR_OVERRIDE_TITLE' | translate }}
        </h4>
        <button
          type="button"
          class="fa fa-times text-xl text-600 cursor-pointer border-none bg-transparent p-0"
          (click)="closeClearOverrideModal()"
          aria-label="close-clear-override-dialog"
        ></button>
      </div>
      <div class="surface-100 p-3">
        <div class="mb-3 -mt-3">
          <p-message
            severity="info"
            icon="fa fa-info-circle"
            aria-label="clear-override-info-message"
          >
            {{ 'SUBSCRIPTIONS.CLEAR_OVERRIDE_INFO' | translate }}
          </p-message>
        </div>
        <label class="font-medium text-700 text-xs mb-2 block uppercase">{{
          'SUBSCRIPTIONS.CLEAR_OVERRIDE_REASON' | translate
        }}</label>
        <textarea
          formControlName="override_change_reason"
          class="text-sm w-full h-5rem p-2 border-1 border-300 border-round"
          aria-label="clear-override-reason-input"
        ></textarea>
        @if (
          ClearOverrideReasonFormControl.touched &&
          ClearOverrideReasonFormControl.invalid
        ) {
          <small class="p-error block mt-1">
            {{ 'SUBSCRIPTIONS.CLEAR_OVERRIDE_REASON' | translate }}
            {{ 'common.errors.REQUIRED' | translate }}
          </small>
        }
      </div>
      <div
        class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
      >
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-primary p-button-text text-sm"
          (click)="closeClearOverrideModal()"
          aria-label="cancel-clear-override"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          [label]="'SUBSCRIPTIONS.BTN_CLEAR_OVERRIDE' | translate"
          class="p-button-primary text-sm"
          [loading]="clearOverrideBtnLoading"
          (click)="submitClearOverride()"
          aria-label="confirm-clear-override"
        ></button>
      </div>
    </form>
  </ng-template>
</p-dialog>
